import { createContext } from 'react';

type SettingsContext = {
  schoolName: string;
  schoolTel: string;
  schoolMail: string;
  schoolAddress: string;
  businessHour: {
    open: {
      hour: string;
      minute: string;
    };
    close: {
      hour: string;
      minute: string;
    };
  };
  businessHours: (string | number)[];
  transferTicketTiming: number;
};

const SettingsContext = createContext<SettingsContext>({
  schoolName: '',
  schoolTel: '',
  schoolMail: '',
  schoolAddress: '',
  businessHour: {
    open: {
      hour: '0',
      minute: '0',
    },
    close: {
      hour: '0',
      minute: '0',
    },
  },
  businessHours: [],
  transferTicketTiming: 1,
});

export default SettingsContext;
